/**
 * ユーザーIDから一貫した色を生成する関数
 * 同じユーザーIDは常に同じ色を返す
 */
export const getUserColorFromId = (userId: string): string => {
  const colors = [
    'from-purple-400 to-pink-600',
    'from-blue-400 to-cyan-600',
    'from-green-400 to-emerald-600',
    'from-yellow-400 to-orange-600',
    'from-red-400 to-rose-600',
    'from-indigo-400 to-purple-600',
    'from-teal-400 to-green-600',
    'from-pink-400 to-rose-600',
  ];

  // UUIDの最初の8文字（ハイフン除く）を16進数として解釈
  // より均等な分散を実現
  const hexPart = userId.replace(/-/g, '').substring(0, 8);
  const numericValue = parseInt(hexPart, 16);
  const index = numericValue % colors.length;

  return colors[index];
};

/**
 * ニックネームまたはメールアドレスから先頭2文字を取得
 */
export const getUserInitial = (nickname?: string | null, email?: string | null): string => {
  const text = nickname || email || '??';
  // 先頭2文字を取得（1文字しかない場合は1文字のみ）
  return text.substring(0, 2).toUpperCase();
};
